import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { themeOverrides as i } from "../../constants/themeConfig.js";
import { vCopyVueucStylesToShadowDom as p } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { vShadowPropertyPolyfill as s } from "../../utils/vShadowPropertyPolyfill.js";
import u from "./OrderCycleContent.vue.js";
import { defineComponent as y, useTemplateRef as a, withDirectives as C, openBlock as _, createBlock as h, withCtx as d, createElementVNode as v, createVNode as c } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as x } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import g from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const $ = /* @__PURE__ */ y({
  __name: "OrderCycle.ce",
  setup(k, { expose: f }) {
    const o = x(), r = a("orderCycleIndex"), t = a("orderCycleContentRef");
    return f({ open: (m, l) => {
      var n;
      return (n = t.value) == null ? void 0 : n.open(m, l);
    } }), (m, l) => C((_(), h(e(R), {
      "style-mount-target": e(o),
      locale: e(N),
      "date-locale": e(w),
      "theme-overrides": e(i)
    }, {
      default: d(() => [
        v("div", {
          ref_key: "orderCycleIndex",
          ref: r
        }, null, 512),
        c(e(g), {
          to: r.value || "body"
        }, {
          default: d(() => [
            c(u, {
              ref_key: "orderCycleContentRef",
              ref: t
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["style-mount-target", "locale", "date-locale", "theme-overrides"])), [
      [e(p), e(o)],
      [e(s), e(o)]
    ]);
  }
});
export {
  $ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/order-cycle/OrderCycle.ce.vue2.js
// module id = 1314
// module chunks = 67